(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let breadcrumbHeight = '';
      
      var mediaTop = this.headerBounds.bottom;
      // console.log('scrollTop: ' + scrollTop);
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
        document.querySelectorAll('.product__media-sticky').forEach(stickyItem => {
          stickyItem.style.top = 0;
        })
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
          
          if(document.querySelector('.breadcrumb')) {
            breadcrumbHeight = document.querySelector('.breadcrumb').offsetHeight;
            
            if(scrollTop > (this.headerBounds.bottom + breadcrumbHeight)) {
              document.body.classList.add('sticky-header-visible--product');
              document.querySelectorAll('.product__media-sticky').forEach(stickyItem => {
                stickyItem.style.top = this.headerBounds.bottom + 'px';
                mediaTop = this.headerBounds.bottom;
              })
            } else if (scrollTop <= (this.headerBounds.bottom + breadcrumbHeight)) {
              mediaTop - 1;
              document.querySelectorAll('.product__media-sticky').forEach(stickyItem => {
                stickyItem.style.top = mediaTop + 'px';
              })
            }
          }
        } else { 
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          document.querySelectorAll('.product__media-sticky').forEach(stickyItem => {
          stickyItem.style.top = 0;
          })

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
        document.querySelectorAll('.product__media-sticky').forEach(stickyItem => {
          stickyItem.style.top = 0;
        })
      }

      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
      if (typeof articleRelatedContent !== 'undefined') {
        articleRelatedContent.classList.remove('header-showing');
      }
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (typeof articleRelatedContent !== 'undefined') {
        articleRelatedContent.classList.add('header-showing');
      }
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (typeof articleRelatedContent !== 'undefined') {
        articleRelatedContent.classList.remove('header-showing');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);

  if(document.querySelector('.announcement-bar__close')) {
    document.querySelector('.announcement-bar__close').addEventListener('click', (event) => {
      event.target.closest('.announcement-bar').setAttribute('aria-hidden', true);
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      let breadcrumbHeight = '';
      
      var mediaTop = this.headerBounds.bottom;
      // console.log('scrollTop: ' + scrollTop);
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
        document.querySelectorAll('.product__media-sticky').forEach(stickyItem => {
          stickyItem.style.top = 0;
        })
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
          
          if(document.querySelector('.breadcrumb')) {
            breadcrumbHeight = document.querySelector('.breadcrumb').offsetHeight;
            
            if(scrollTop > (this.headerBounds.bottom + breadcrumbHeight)) {
              document.body.classList.add('sticky-header-visible--product');
              document.querySelectorAll('.product__media-sticky').forEach(stickyItem => {
                stickyItem.style.top = this.headerBounds.bottom + 'px';
                mediaTop = this.headerBounds.bottom;
              })
            } else if (scrollTop <= (this.headerBounds.bottom + breadcrumbHeight)) {
              mediaTop - 1;
              document.querySelectorAll('.product__media-sticky').forEach(stickyItem => {
                stickyItem.style.top = mediaTop + 'px';
              })
            }
          }
        } else { 
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          document.querySelectorAll('.product__media-sticky').forEach(stickyItem => {
          stickyItem.style.top = 0;
          })

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
        document.querySelectorAll('.product__media-sticky').forEach(stickyItem => {
          stickyItem.style.top = 0;
        })
      }

      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
      if (typeof articleRelatedContent !== 'undefined') {
        articleRelatedContent.classList.remove('header-showing');
      }
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (typeof articleRelatedContent !== 'undefined') {
        articleRelatedContent.classList.add('header-showing');
      }
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (typeof articleRelatedContent !== 'undefined') {
        articleRelatedContent.classList.remove('header-showing');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);

  if(document.querySelector('.announcement-bar__close')) {
    document.querySelector('.announcement-bar__close').addEventListener('click', (event) => {
      event.target.closest('.announcement-bar').setAttribute('aria-hidden', true);
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer-hulkapps-backup"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            ...{
              body,
            },
          });
        }, 300)
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            ...{
              body,
            },
          });
        }, 300)
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items-hulkapps-backup"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            ...{
              body,
            },
          });
        }, 300)
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            ...{
              body,
            },
          });
        }, 300)
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
